import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-units-blocked-modal",
  templateUrl: "./units-blocked-modal.component.html",
  styleUrls: ["./units-blocked-modal.component.scss"],
  standalone: false,
})
export class UnitsBlockedModalComponent {
  constructor(public dialogRef: MatDialogRef<UnitsBlockedModalComponent>) {}

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close();
  }
}
